module.exports = __webpack_public_path__ + "img/logo.ff88ef5c.png";